"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const errorMessage_1 = __importDefault(require("../errorMessage/errorMessage"));
const textArea_style_1 = __importDefault(require("./textArea.style"));
const status_1 = require("../constants/status");
class TextArea extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            hasFocus: false,
            focusCounter: 0
        };
        this.handleFocus = e => {
            window.clearTimeout(this.timer);
            this.setState({
                hasFocus: true
            });
            this.props.handleFocus(e);
        };
        this.handleBlur = e => {
            const { required } = this.props;
            const { focusCounter } = this.state;
            window.clearTimeout(this.timer);
            this.timer = window.setTimeout(() => {
                this.setState({
                    hasFocus: false,
                    focusCounter: required ? focusCounter + 1 : 0
                });
                this.props.handleBlur(e);
            }, 50);
        };
        this.render = () => {
            const { classes, id, value, placeholder, handleChange, inputRef, status, disabled, rows, errorMessage, required, noResize } = this.props;
            const { focusCounter } = this.state;
            /**
             * the regex checks for a line with only white spaces.
             */
            const invalid = (value === '' || value.match(/^[ \t\r\n\s]*$/g)) &&
                focusCounter > 0 &&
                required;
            const rootProps = {
                className: classes.root,
                'data-has-focus': this.state.hasFocus,
                'data-has-value': !!value.length,
                'data-is-invalid': status === status_1.STATUS_INVALID || (invalid === null ? false : invalid),
                'data-is-caution': status === status_1.STATUS_CAUTION,
                'data-is-valid': status === status_1.STATUS_VALID,
                'data-is-modified': status === status_1.STATUS_MODIFIED,
                'data-is-disabled': disabled,
                'data-is-required': required
            };
            const textAreaProps = {
                className: classes.textarea,
                id,
                value,
                placeholder,
                onFocus: this.handleFocus,
                onBlur: this.handleBlur,
                onChange: handleChange,
                ref: inputRef,
                disabled,
                rows,
                'data-is-not-resizeable': noResize
            };
            return (jsx_runtime_1.jsxs("div", Object.assign({}, rootProps, { children: [jsx_runtime_1.jsx("textarea", Object.assign({}, textAreaProps), void 0),
                    invalid && errorMessage && jsx_runtime_1.jsx(errorMessage_1.default, { text: errorMessage }, void 0)] }), void 0));
        };
    }
}
exports.TextArea = TextArea;
TextArea.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    id: prop_types_1.default.string,
    value: prop_types_1.default.string.isRequired,
    placeholder: prop_types_1.default.string,
    handleFocus: prop_types_1.default.func,
    handleBlur: prop_types_1.default.func,
    handleChange: prop_types_1.default.func,
    inputRef: prop_types_1.default.func,
    suffix: prop_types_1.default.node,
    status: prop_types_1.default.oneOf([
        status_1.STATUS_INVALID,
        status_1.STATUS_CAUTION,
        status_1.STATUS_VALID,
        status_1.STATUS_MODIFIED
    ]),
    disabled: prop_types_1.default.bool,
    rows: prop_types_1.default.number,
    errorMessage: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    noResize: prop_types_1.default.bool
};
TextArea.defaultProps = {
    id: null,
    placeholder: null,
    handleFocus: () => { },
    handleBlur: () => { },
    handleChange: () => { },
    inputRef: () => { },
    suffix: null,
    status: null,
    disabled: false,
    rows: null,
    errorMessage: '',
    required: false,
    noResize: false
};
exports.default = react_jss_1.default(textArea_style_1.default)(TextArea);
//# sourceMappingURL=textArea.js.map